import { render } from "./GrupoList.vue?vue&type=template&id=0ea07b8f"
import script from "./GrupoList.vue?vue&type=script&lang=js"
export * from "./GrupoList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\hd\\git\\enuve\\app-cliente\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__